import { useTranslate } from '@refinedev/core';
import { Space } from 'antd';
import { BulkModStatusControl } from '@/components/user_catalog/BulkModStatusControl';
import type { BulkRowSelection } from '@/hooks/user_catalog/useBulkRowSelection';

interface BulkModStatusBarProps<T> {
  /** Refine resource string, e.g. `user_catalog.tags` */
  resource: string;
  selection: BulkRowSelection<T>;
}

/**
 * List toolbar over the selected rows: count against the cap and the status
 * dropdown. After a run only the refused rows stay selected — the ones that
 * still need attention.
 */
export const BulkModStatusBar = <T,>({
  resource,
  selection,
}: BulkModStatusBarProps<T>) => {
  const t = useTranslate();
  const { selectedIds, setSelectedIds, labelOf, limit } = selection;
  if (selectedIds.length === 0) return null;

  return (
    <Space style={{ marginBottom: 16 }}>
      <span>
        {t('user_catalog.common.bulk_mod_status.selected_of', {
          count: selectedIds.length,
          limit,
        })}
      </span>
      <BulkModStatusControl
        resource={resource}
        ids={selectedIds}
        labelOf={labelOf}
        onSuccess={({ refused }) => setSelectedIds(refused)}
      />
    </Space>
  );
};
